import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialAngularModule } from '../material-design/material.module';
import { CadastroPageComponent } from './cadastro-page/cadastro-page.component';
import { CadastroFormComponent } from './cadastro-form/cadastro-form.component';
import { ConfirmarCadastroPageComponent } from './confirmar-cadastro-page/confirmar-cadastro-page.component';
import { ConfirmarCadastroFormComponent } from './confirmar-cadastro-form/confirmar-cadastro-form.component';
import { SharedDirectivesModule } from '../shared/directives/shared-directives.module';
import { NgOtpInputModule } from 'ng-otp-input';
import { PasswordRecoveryModule } from '../password-recovery/password-recovery.module';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MaterialAngularModule,
    ReactiveFormsModule,
    SharedDirectivesModule,
    NgOtpInputModule,
    PasswordRecoveryModule,
    RouterModule
  ],
  declarations: [
    CadastroPageComponent,
    CadastroFormComponent,
    ConfirmarCadastroPageComponent,
    ConfirmarCadastroFormComponent,
  ],
})
export class CadastroModule { }